// 🔧 request_intake_options.js
// ✅ Purpose: Shared dropdown options for public event request intake fields
// ✅ Features:
// - Provides estimated attendance options
// - Provides "how did you hear about us" options
// - Keeps request_event.js, pending_event.js, and event.js consistent

export const ATTENDANCE_ESTIMATES = [
  { value: "under_100", label: "Under 100" },
  { value: "100_250", label: "100–250" },
  { value: "250_500", label: "250–500" },
  { value: "500_1000", label: "500–1,000" },
  { value: "1000_plus", label: "1,000+" },
  { value: "not_sure", label: "Not sure yet" },
];

export const HOW_HEARD_OPTIONS = [
  { value: "google", label: "Google Search" },
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "friend_referral", label: "Friend / Referral" },
  { value: "event_organizer", label: "Event Organizer" },
  { value: "existing_event", label: "Existing Let's Go Vote Event" },
  { value: "car_show", label: "Car Show" },
  { value: "other", label: "Other" },
];